export default class foreignKeyClass {
  tuoteId;
  asiakasId;
  foreignKey;
  foreignKeySourceId;
  foreignKeySourceName;
  constructor(tuoteId) {
    this.tuoteId = tuoteId;
    this.asiakasId = 0;
    this.foreignKey = "";
    this.foreignKeySourceId = 1;
    this.foreignKeySourceName = "";
  }
}
